import { useMutation } from '@tanstack/react-query';
import { POST, POST_INSERT_STORE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { createFocusShop } from '../../../resources/payload';

export const useInsertStore = ({ onSuccessCallBack, onErrorCallBack }) =>
  useMutation({
    mutationFn: async ({ ...values }) => {
      const payload = createFocusShop(values);
      const response = await POST(POST_INSERT_STORE(), payload);
      return response;
    },
    onSuccess: (response) => {
      console.log('response', response);
      if (onSuccessCallBack) onSuccessCallBack(response);
    },
    onError: (err) => {
      console.log('err', err);
      openAlert({
        model: 'message',
        type: 'error',
        message: err?.message || 'เพิ่มร้านค้าไม่สำเร็จ',
      });
      if (onErrorCallBack) onErrorCallBack();
    },
  });
